import { captureSentryException } from "utility/capture_sentry_exception";

// -----------------------------------------------------------------------------

export function isPermissionLevel(
  userStore: any,
  permissionLevel: string
): boolean {
  return userStore?.user?.permissionLevel === permissionLevel;
}

export function canInvite(userStore: any): boolean {
  return (
    isPermissionLevel(userStore, "SuperAdmin") ||
    isPermissionLevel(userStore, "Admin")
  );
}

/** Copies `innerText.trim()` for an element to the clipboard. */
export async function copyToClipboard(element: HTMLElement): Promise<void> {
  window?.getSelection()?.selectAllChildren(element);
  return await navigator?.clipboard?.writeText(element.innerText.trim()).then(
    () => console.log("Copied to clipboard"),
    (error) => {
      captureSentryException(error, "Failed to copy to clipboard");
    }
  );
}

// -----------------------------------------------------------------------------

const CurrencyFormatter: Record<string, Intl.NumberFormat> = {};

export function toCurrency(amount: number, currency: string = "USD"): string {
  const currencyProcessed = String(currency || "USD").toUpperCase();
  const amountRaw = amount || 0;
  const amountProcessed = isFractionalCurrency(currencyProcessed)
    ? Math.max(amount / 100, 0)
    : amountRaw;

  //
  return getCurrencyFormatter(currencyProcessed).format(amountProcessed);
}

function isFractionalCurrency(currency: string): boolean {
  switch (currency) {
    case "USD": // only currency accepted
      return true;

    default:
      return false;
  }
}

function getCurrencyFormatter(currency: string): Intl.NumberFormat {
  CurrencyFormatter[currency] =
    CurrencyFormatter[currency] ||
    new Intl.NumberFormat(undefined, {
      style: "currency",
      currency,
      // not in the current typing
      trailingZeroDisplay: "stripIfInteger",
    } as any);

  //
  return CurrencyFormatter[currency];
}

// -----------------------------------------------------------------------------

export type ModalOnCloseCallback = (
  event: {},
  reason: "backdropClick" | "escapeKeyDown"
) => void;

export interface GenericObject {
  [key: string]: any;
}
